exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#chisocongtochitiet .ngay input {\n  width: 100% !important; }\n\n#chisocongtochitiet .ui-calendar {\n  width: 100% !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/views/giam-sat/chi-so-cong-to-kh/chi-tiet/chisocongtokh-chitiet.component.scss
// module id = ../../../../../src/app/views/giam-sat/chi-so-cong-to-kh/chi-tiet/chisocongtokh-chitiet.component.scss
// module chunks = main